'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mediPimData = mediPimData;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function mediPimData() {
    var clazz = function MediPimData() {
        var defaults = {
            description: '',
            fullDescription: '',
            NUT: '',
            ATC: '',
            EAN: '',
            UDI: '',
            prescription: false,
            properties: '',
            usage: '',
            composition: '',
            contraIndication: '',
            sideEffects: '',
            indication: '',
            images: [],
            height: 0,
            width: 0,
            depth: 0,
            weight: 0,
            brands: [],
            apbCategory: '',
            categories: [],
            tax: 0,
            media: [],
            faggPublicNotice: '',
            faggSpecialNotice: '',
            pharmaPublicNotice: '',
            pharmaSpecialNotice: '',
            laboPublicNotice: '',
            laboSpecialNotice: '',
            packageQuantity: '',
            conservation: '',
            pharmacistPrice: 0,
            expires: false,
            supplierReference: '',
            tradeInMonthsBeforeExpiry: 0,
            tradeInMonthsAfterExpiry: 0,
            tradeInRefundValue: 0,
            status: '',
            ctiExtended: '',
            refundValueWithOmnio: 0,
            refundValueWithoutOmnio: 0,
            attributes: [],
            activeIngredients: [],
            suppliers: [],
            shortDescription: '',
            frontals: [],
            writtenRequestByPatient: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var data = new clazz();
        data.description = resource.description;
        data.fullDescription = resource.fullDescription;
        data.NUT = resource.nut;
        data.ATC = resource.atc;
        data.EAN = resource.ean;
        data.GTIN = resource.gtin;
        data.UDI = resource.udi;
        data.prescription = resource.prescription;
        data.properties = resource.properties;
        data.usage = resource.usage;
        data.composition = resource.composition;
        data.contraIndication = resource.contraIndication;
        data.sideEffects = resource.sideEffects;
        data.indication = resource.indication;
        data.images = resource.images;
        data.height = resource.height;
        data.width = resource.width;
        data.depth = resource.depth;
        data.weight = resource.weight;
        data.brands = resource.brands;
        data.apbCategory = resource.apbCategory;
        data.categories = resource.categories;
        data.tax = resource.tax;
        data.media = resource.media;
        data.faggPublicNotice = resource.faggPublicNotice;
        data.faggSpecialNotice = resource.faggSpecialNotice;
        data.pharmaPublicNotice = resource.pharmaPublicNotice;
        data.pharmaSpecialNotice = resource.pharmaSpecialNotice;
        data.laboPublicNotice = resource.laboPublicNotice;
        data.laboSpecialNotice = resource.laboSpecialNotice;
        data.packageQuantity = resource.packageQuantity;
        data.conservation = resource.conservation;
        data.pharmacistPrice = resource.pharmacistPrice;
        data.expires = resource.expires;
        data.supplierReference = resource.supplierReference;
        data.tradeInMonthsBeforeExpiry = resource.tradeInMonthsBeforeExpiry;
        data.tradeInMonthsAfterExpiry = resource.tradeInMonthsAfterExpiry;
        data.tradeInRefundValue = resource.tradeInRefundValue;
        data.status = resource.status;
        data.ctiExtended = resource.ctiExtended;
        data.refundValueWithOmnio = resource.refundValueWithOmnio;
        data.refundValueWithoutOmnio = resource.refundValueWithoutOmnio;
        data.attributes = resource.attributes;
        data.activeIngredients = resource.activeIngredients;
        data.suppliers = resource.suppliers;
        data.shortDescription = resource.shortDescription;
        data.frontals = resource.frontals;
        data.writtenRequestByPatient = resource.writtenRequestByPatient;
        return data;
    };

    clazz.createFromLocalStorage = function (resource) {
        var data = new clazz();
        data.description = resource.description;
        data.fullDescription = resource.fullDescription;
        data.NUT = resource.nut;
        data.ATC = resource.atc;
        data.EAN = resource.ean;
        data.GTIN = resource.gtin;
        data.UDI = resource.udi;
        data.prescription = resource.prescription;
        data.properties = resource.properties;
        data.usage = resource.usage;
        data.composition = resource.composition;
        data.contraIndication = resource.contraIndication;
        data.sideEffects = resource.sideEffects;
        data.indication = resource.indication;
        data.images = resource.images;
        data.height = resource.height;
        data.width = resource.width;
        data.depth = resource.depth;
        data.weight = resource.weight;
        data.brands = resource.brands;
        data.apbCategory = resource.apbCategory;
        data.categories = resource.categories;
        data.tax = resource.tax;
        data.media = resource.media;
        data.faggPublicNotice = resource.faggPublicNotice;
        data.faggSpecialNotice = resource.faggSpecialNotice;
        data.pharmaPublicNotice = resource.pharmaPublicNotice;
        data.pharmaSpecialNotice = resource.pharmaSpecialNotice;
        data.laboPublicNotice = resource.laboPublicNotice;
        data.laboSpecialNotice = resource.laboSpecialNotice;
        data.packageQuantity = resource.packageQuantity;
        data.conservation = resource.conservation;
        data.pharmacistPrice = resource.pharmacistPrice;
        data.expires = resource.expires;
        data.supplierReference = resource.supplierReference;
        data.tradeInMonthsBeforeExpiry = resource.tradeInMonthsBeforeExpiry;
        data.tradeInMonthsAfterExpiry = resource.tradeInMonthsAfterExpiry;
        data.tradeInRefundValue = resource.tradeInRefundValue;
        data.status = resource.status;
        data.ctiExtended = resource.ctiExtended;
        data.refundValueWithOmnio = resource.refundValueWithOmnio;
        data.refundValueWithoutOmnio = resource.refundValueWithoutOmnio;
        data.attributes = resource.attributes;
        data.activeIngredients = resource.activeIngredients;
        data.suppliers = resource.suppliers;
        data.frontals = resource.frontals;
        data.shortDescription = resource.shortDescription;
        data.writtenRequestByPatient = resource.writtenRequestByPatient;
        return data;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/mediPimDataModel.js
// module id = 757
// module chunks = 0